// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "screen and (max-width: 600px)";
var _3 = "root-2Hqh8";
var _4 = "info-2qvRU";
var _5 = "copy-38gx0";
export { _1 as "__esModule", _2 as "mobile", _3 as "root", _4 as "info", _5 as "copy" }
export default { "__esModule": _1, "mobile": _2, "root": _3, "info": _4, "copy": _5 }
